function generateTraceId() {
  try {
    const array = new Uint32Array(4);
    crypto.getRandomValues(array);
    return Array.from(array, (n) => n.toString(16).padStart(8, "0")).join("-");
  } catch {
    const timePart = Date.now().toString(36);
    const randPart = Math.random().toString(36).substring(2, 10);
    return `${timePart}-${randPart}`;
  }
}

const traceId = generateTraceId();

export function getTraceId() {
  return traceId;
}
